import { Update } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TrainingProgramEntity } from './training-program.model';

export enum TrainingProgramActionTypes {
  LoadTrainingPrograms = '[TrainingProgram] Load TrainingPrograms',
  AddTrainingProgram = '[TrainingProgram] Add TrainingProgram',
  UpsertTrainingProgram = '[TrainingProgram] Upsert TrainingProgram',
  AddTrainingPrograms = '[TrainingProgram] Add TrainingPrograms',
  UpsertTrainingPrograms = '[TrainingProgram] Upsert TrainingPrograms',
  UpdateTrainingProgram = '[TrainingProgram] Update TrainingProgram',
  UpdateTrainingPrograms = '[TrainingProgram] Update TrainingPrograms',
  DeleteTrainingProgram = '[TrainingProgram] Delete TrainingProgram',
  DeleteTrainingPrograms = '[TrainingProgram] Delete TrainingPrograms',
  ClearTrainingPrograms = '[TrainingProgram] Clear TrainingPrograms',
}

export class LoadTrainingPrograms implements Action {
  public readonly type = TrainingProgramActionTypes.LoadTrainingPrograms;

  constructor(public payload: { trainingPrograms: TrainingProgramEntity[] }) {}
}

export class AddTrainingProgram implements Action {
  public readonly type = TrainingProgramActionTypes.AddTrainingProgram;

  constructor(public payload: { trainingProgram: TrainingProgramEntity }) {}
}

export class UpsertTrainingProgram implements Action {
  public readonly type = TrainingProgramActionTypes.UpsertTrainingProgram;

  constructor(public payload: { trainingProgram: TrainingProgramEntity }) {}
}

export class AddTrainingPrograms implements Action {
  public readonly type = TrainingProgramActionTypes.AddTrainingPrograms;

  constructor(public payload: { trainingPrograms: TrainingProgramEntity[] }) {}
}

export class UpsertTrainingPrograms implements Action {
  public readonly type = TrainingProgramActionTypes.UpsertTrainingPrograms;

  constructor(public payload: { trainingPrograms: TrainingProgramEntity[] }) {}
}

export class UpdateTrainingProgram implements Action {
  public readonly type = TrainingProgramActionTypes.UpdateTrainingProgram;

  constructor(public payload: { trainingProgram: Update<TrainingProgramEntity> }) {}
}

export class UpdateTrainingPrograms implements Action {
  public readonly type = TrainingProgramActionTypes.UpdateTrainingPrograms;

  constructor(public payload: { trainingPrograms: Update<TrainingProgramEntity>[] }) {}
}

export class DeleteTrainingProgram implements Action {
  public readonly type = TrainingProgramActionTypes.DeleteTrainingProgram;

  constructor(public payload: { id: string }) {}
}

export class DeleteTrainingPrograms implements Action {
  public readonly type = TrainingProgramActionTypes.DeleteTrainingPrograms;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearTrainingPrograms implements Action {
  public readonly type = TrainingProgramActionTypes.ClearTrainingPrograms;
}

export type TrainingProgramActions =
  | LoadTrainingPrograms
  | AddTrainingProgram
  | UpsertTrainingProgram
  | AddTrainingPrograms
  | UpsertTrainingPrograms
  | UpdateTrainingProgram
  | UpdateTrainingPrograms
  | DeleteTrainingProgram
  | DeleteTrainingPrograms
  | ClearTrainingPrograms;
